import { createUseStyles } from "react-jss";
import { down } from "../../styles/breakpoints";

type Props = {
  width?: string | number;
};

const useStyles = createUseStyles(() => ({
  containerDialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      width: (props: Props) => (props.width ? props.width : "383px"),
      /*
       * This selector is more specific than the `.MuiDialog-paper` cap in
       * index.css, so the fixed `width` above used to win and every modal
       * overflowed horizontally on a phone. The cap is repeated here.
       */
      maxWidth: "100%",
      borderRadius: "15px",
      padding: "20px",
      [down.sm]: {
        padding: "16px",
      },
    },
  },

  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    minWidth: 0,
  },

  /* Action buttons wrap onto a second line rather than overflowing the
     dialog when their labels are long or the screen is narrow. */
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
    [down.xs]: {
      flexDirection: "column",
      gap: "10px",
    },
  },
}));

export default useStyles;
